import { render } from "./access-denied.vue?vue&type=template&id=dabf38e8&scoped=true&ts=true"
import script from "./access-denied.ts?vue&type=script&lang=ts&external"
export * from "./access-denied.ts?vue&type=script&lang=ts&external"

import "./access-denied.scss?vue&type=style&index=0&id=dabf38e8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dabf38e8"]])

export default __exports__